import { ActionTree }                             from 'vuex';
import { RootState }                              from '@/store/store.types';
import { Season, SeasonNumberDate, SeasonsState } from '@/views/seasons/seasons.types';
import { Notification }                           from '@/components/notification/notification';
import { getDatesWithCode }                       from '@/views/seasons/helpers/season.helpers';
import i18n                                       from '@/i18n';
import * as seasonsService                        from '../seasons.service';

const actions: ActionTree<SeasonsState, RootState> = {
  async getAllSeasons(context): Promise<void> {
    try {
      const { data }: { data: Season[] } = await seasonsService.getAllSeasons();
      context.commit('addSeasons', data);
      data.forEach((season: Season) => {
        if (season.dayOfYears) {
          season.dayOfYears.forEach((date: SeasonNumberDate) => {
            context.commit('updateCalendar', {
              day: date.dayNumber,
              month: date.monthNumber - 1,
              code: season.code,
            });
          });
        }
      });
    } catch (e) {
      throw new Error(e);
    }
  },
  async saveAllSeasons(context): Promise<void> {
    context.commit('setLoading', true);

    const result: Season[] = context.state.seasons
      .map((season: Season, index: number) => ({
        ...season,
        order: index,
        dayOfYears: getDatesWithCode(context.state.calendar, season.code),
      }));

    try {
      await seasonsService.putAllSeasons(result);

      Notification.success(
        i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.success`),
        i18n.t('vSeasons.notification.seasons.success'),
      );
    } catch (e) {
      const errors: Array<{ reason: string; field: string }> | null = e.response.data;

      if (errors && errors[ 0 ]) {
        try {
          if (errors[ 0 ].reason === 'MUST_NOT_BE_EMPTY') {
            const seasonIndex: string = (errors[ 0 ].field.match(/seasons\[(.+)\]/) as string[])[ 1 ];
            const season: Season = context.state.seasons[ +seasonIndex ];
            Notification.error(
              i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.errors.error`),
              i18n.t(`vSeasons.notification.${errors[ 0 ].reason}`, [ season.name ]),
            );
          } else {
            Notification.error(
              i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.errors.error`),
              i18n.t(`vSeasons.notification.${errors[ 0 ].reason}`),
            );
          }

          return;
        } catch (e) {
          throw new Error(e);
        }
      }

      Notification.error(
        i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.errors.error`),
        i18n.t('vSeasons.notification.seasons.error'),
      );
    } finally {
      context.commit('setLoading', false);
    }
  },
};

export default actions;
